"use client";

import { cn } from "@resume-studio/utils";

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("animate-pulse rounded-lg bg-secondary", className)} {...props} />
);
